export default __webpack_public_path__ + "static/media/300-250_1.2d573bcf.png";